import { map } from 'lodash';
import React from 'react';

const testimonials = [
  {
    quote:
      "DigitMoney's strategies helped us cut our customer acquisition cost by over 30% in just three months.",
    name: 'Ravi Mehra',
    title: 'VP Growth & Partnerships, FinCore Solutions',
    image: 'assets/img/dummy-testimonials.png',
    stars: 5,
    bgColor: 'bg-emerald-800',
    textColor: 'text-white',
  },
  {
    quote:
      "We saw a measurable uptick in lead quality and conversion rates after implementing their data-driven marketing funnels.",
    name: 'Anjali Kapoor',
    title: 'Marketing Head, QuickCash India Pvt. Ltd.',
    image: 'assets/img/dummy-testimonials.png',
    stars: 4,
    bgColor: 'bg-white',
    textColor: 'text-black',
    border: 'border border-purple-300',
  },
  {
    quote:
      "Working with DigitMoney has been a game-changer. Their insights into consumer behavior helped us rework our entire digital approach.",
    name: 'Mohit Rajput',
    title: 'Digital Strategy Lead, LendWise Technologies',
    image: 'assets/img/dummy-testimonials.png',
    stars: 5,
    bgColor: 'bg-emerald-400',
    textColor: 'text-black',
  },
  {
    quote:
      "Our inbound leads have doubled, and we’ve seen an incredible 45% increase in engagement thanks to their campaigns.",
    name: 'Simran Oberoi',
    title: 'Head of Product, BharatLoan',
    image: 'assets/img/dummy-testimonials.png',
    stars: 5,
    bgColor: 'bg-emerald-600',
    textColor: 'text-white',
  },
  {
    quote:
      "What stood out was their focus on long-term success. We aren’t just seeing short spikes—we're building lasting growth.",
    name: 'Arun Verma',
    title: 'Chief Marketing Officer, NeoCredit Pvt. Ltd.',
    image: 'assets/img/dummy-testimonials.png',
    stars: 5,
    bgColor: 'bg-emerald-700',
    textColor: 'text-white',
  },
];


const Testimonials = () => {
    return (
        <div className="bg-black text-white py-12 px-4 sm:px-10">
            <div className="max-w-6xl mx-auto">
                <div className='w-full max-w-7xl flex  flex-col items-start sm:flex-row sm:justify-between sm:items-center'>
                    <p style={{ fontFamily: 'myFirstFont' }} className="[@media(max-width:340px)]:text-[20px] text-[30px] bg-[#12F280] px-3 py-1 text-[#000000] sm:px-4 sm:py-3 inline-block rounded f mb-3 sm:text-[35px]">Testimonials</p>
                    <p style={{ fontFamily: 'Atkinson-regular' }}className='[@media(max-width:340px)]:text-[15px] text-[18px] leading-[1.2] text-[#818181] pb-[30px] sm:hidden'>We don’t just generate leads; we help you acquire long-term customers through data-driven strategies tailored to your business goals.</p>
                    <h2 style={{ fontFamily: 'PP-Hatton-Regular' }} className="[@media(max-width:340px)]:text-[45px] text-[55px] leading-[1] sm:text-5xl lg:text-[100px]  text-[#12F280] mb-8">From Our <br /> Community</h2>
                </div>

                <div className="flex w-screen gap-6 overflow-x-auto pb-4 no-scrollbar">
                    {testimonials.map((item, index) => (
                        <div
                            key={index}
                            className={` flex justify-between flex-col max-w-[294px] sm:min-w-[350px] sm:max-w-[450px] flex-shrink-0 rounded-xl px-[35px] py-[30px] shadow-md ${item.bgColor} ${item.textColor} ${item.border || ''}`}
                        >

                            <div className=''>
                                <img
                                    src="/assets/img/tick.png"
                                    className="h-[28px] w-[33px] mb-1 sm:h-[32px] sm:w-[38px] lg:h-[42px] lg:w-[50px] lg:ml-[-15px]"
                                    alt="tick"
                                />
                                <p style={{ fontFamily: 'Atkinson-regular' }} className="mb-1 w-full text-[14px] sm:text-[16px] md:text-[18px]  ">{item.quote}</p>
                                <div className=" text-[20px] text-yellow-400">
                                    {'★'.repeat(item.stars)}{'☆'.repeat(5 - item.stars)}
                                </div>

                            </div>
                            <div className="flex items-center gap-3 mt-4">
                                <img src={item.image} alt={item.name} className="w-[57px] h-[57px] sm:h-[60px] sm:w-[60px] rounded-full object-cover" />
                                <div style={{ fontFamily: 'Atkinson-regular' }}>
                                    <h4 className="font-bold">{item.name}</h4>
                                    {item.title.split(',').map((i)=>(
                                         <p className="text-sm italic">{i}</p>

                                    ))}
                                </div>
                            </div>

                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Testimonials;
